import { render, staticRenderFns } from "./addproductList.vue?vue&type=template&id=5114784a&scoped=true"
import script from "./addproductList.vue?vue&type=script&lang=js"
export * from "./addproductList.vue?vue&type=script&lang=js"
import style0 from "./addproductList.vue?vue&type=style&index=0&id=5114784a&prod&lang=scss&scoped=true"
import style1 from "./addproductList.vue?vue&type=style&index=1&id=5114784a&prod&lang=css"
import style2 from "./addproductList.vue?vue&type=style&index=2&id=5114784a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5114784a",
  null
  
)

export default component.exports